import NxWallClient from '@nixi1/nx-wall-client'

import { WALL_API } from '../../constants'

const clientInstance = new NxWallClient(WALL_API.URL)

export default { clientInstance }
